<template>
	<div class="home-container" :class="{ 'dark-theme': isDark }">
		<!-- 左侧菜单 -->
		<el-aside width="200px" class="menu-sidebar">
			<el-menu :default-active="activeMenu" class="el-menu-vertical-demo"
				:background-color="isDark ? '#1f1f1f' : '#ffffff'" :text-color="isDark ? '#b0b0b0' : '#303133'"
				:active-text-color="isDark ? '#409eff' : '#409eff'" router>
				<div v-for="menu in menuList" :key="menu.path">
					<el-submenu v-if="hasVisibleChildren(menu)" :index="menu.path">
						<template slot="title">
						<i :class="menu.meta.icon"></i>
						{{menu.meta.menu}}
						</template>
						<el-menu-item v-for="(item,index) in getVisibleChildren(menu)" :key="index" :index="`${item.path}`">
							<i :class="item.meta.icon"></i>
							<span slot="title">{{item.meta.menu}}</span>
						</el-menu-item>
					</el-submenu>
					<el-menu-item v-else :index="`${menu.path}`">
						 <i :class="menu.meta.icon"></i> 
						 <span slot="title">{{ menu.meta.menu }}</span>
					</el-menu-item>
				</div>

			</el-menu>
		</el-aside>

		<!-- 主内容区 -->
		<el-container>
			<!-- 顶部导航栏 -->
			<el-header height="60px" class="top-header">
				<div class="header-left">
					<el-breadcrumb separator="/">
						<el-breadcrumb-item :to="{ path: '/home/dashboard' }">首页</el-breadcrumb-item>
						<el-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="index">
							{{ item.name }}
						</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="header-right">
					<!-- 主题切换 -->
					<el-button type="text" @click="toggleTheme" class="theme-toggle">
						<i :class="isDark ? 'el-icon-sunny' : 'el-icon-moon'" style="font-size: 18px" />
					</el-button>
					<!-- 用户头像 -->
					<el-dropdown @command="handleUserCommand">
						<div class="user-avatar">
							<img src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" alt="用户头像" />
							<span class="user-name">{{ user ? user.username : '管理员' }}</span>
						</div>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
							<el-dropdown-item command="logout">退出登录</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</el-header>

			<!-- 内容区域 -->
			<el-main class="main-content" style="padding: 0;">
			<TabBar />
			<el-card>
				<keep-alive :include="cachedComponentNames">
					<router-view :key="$route.fullPath" />
				</keep-alive>
			</el-card>
				<div class="icp">
					黔ICP备2026005826号
				</div>
			</el-main>
		</el-container>

		<!-- 修改密码弹窗 -->
		<el-dialog title="修改密码" :visible.sync="showPasswordDialog" width="500px">
			<el-form :model="passwordForm" :rules="passwordRules" ref="passwordFormRef" label-width="80px">
				<el-form-item label="旧密码" prop="oldPassword">
					<el-input type="password" v-model="passwordForm.oldPassword" placeholder="请输入旧密码" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newPassword">
					<el-input type="password" v-model="passwordForm.newPassword" placeholder="请输入新密码" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="confirmNewPassword">
					<el-input type="password" v-model="passwordForm.confirmNewPassword" placeholder="请再次输入新密码" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="showPasswordDialog = false">取消</el-button>
				<el-button type="primary" @click="handlePasswordSubmit" :loading="passwordLoading">确认修改</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import api from '../utils/api'
	import TabBar from '@/components/TabBar.vue'

	export default {
		name: 'Main',
		components: {
			TabBar
		},
		data() {
			return {
				isDark: false,
				menuRefreshKey: 0,
				breadcrumbList: [],
				showPasswordDialog: false,
				passwordLoading: false,
				passwordForm: {
					oldPassword: '',
					newPassword: '',
					confirmNewPassword: ''
				},
				passwordRules: {
					oldPassword: [
						{ required: true, message: '请输入旧密码', trigger: 'blur' }
					],
					newPassword: [
						{ required: true, message: '请输入新密码', trigger: 'blur' },
						{ min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
					],
					confirmNewPassword: [
						{ required: true, message: '请再次输入新密码', trigger: 'blur' },
						{
							validator: (rule, value, callback) => {
								if (value !== this.passwordForm.newPassword) {
									callback(new Error('两次输入的密码不一致'))
								} else {
									callback()
								}
							},
							trigger: 'blur'
						}
					]
				}
			}
		},
		computed: {
			activeMenu() {
				return this.$route.path
			},
			menuList() {
				this.menuRefreshKey
				
				// 从路由配置中获取菜单列表
				let homeRoute = localStorage.getItem('menus')//.find(route => route.path === '/home')
				homeRoute=homeRoute?JSON.parse(homeRoute):[]
				 const dataList  =  homeRoute.filter((item)=>{
					return !item.hidden
				})
				return dataList 
				
				return homeRoute
				if (homeRoute && homeRoute.children) {
					return homeRoute.children.filter(route => route.meta && route.meta.menu)
				}
				return []
			},	
			user() {
				return this.$store.getters.getUser
			},
			cachedComponentNames() {
				const names = this.$store.state.tabs.tabs.map(t => t.componentName).filter(Boolean)
				return [...new Set(names)].join(',')
			}
		},
		watch: {
			$route: {
				handler() {
					this.updateBreadcrumb()
					this.$nextTick(() => {
						const matched = this.$route.matched
						const last = matched[matched.length - 1]
						const componentDef = last?.components?.default
						let componentName = ''
						if (typeof componentDef === 'function') {
							componentName = componentDef.name || ''
						} else if (componentDef) {
							componentName = componentDef.name || componentDef.options?.name || ''
						}
						this.$store.dispatch('tabs/openTab', {
							route: this.$route,
							componentName
						})
					})
				},
				immediate: true
			}
		},
		mounted() {
			window.addEventListener('menus-updated', this.handleMenusUpdated)
			// 从本地存储加载主题设置
			const theme = localStorage.getItem('theme')
			if (theme === 'dark') {
				this.isDark = true
				this.setDarkTheme()
			}
			// 初始化时触发主题事件，通知子组件
			this.$nextTick(() => {
				this.$root.$emit('theme-change', this.isDark)
			})

			// 检查是否有token，如果有则获取用户信息
			const token = localStorage.getItem('token')
			if (token && !this.user) {
				this.getUserInfo()
			}
		},
		methods: {
			handleMenusUpdated() {
				this.menuRefreshKey += 1
			},
			getVisibleChildren(menu) {
				return (menu.children || []).filter(item => !item.hidden)
			},
			hasVisibleChildren(menu) {
				return this.getVisibleChildren(menu).length > 0
			},
			updateBreadcrumb() {
				this.breadcrumbList = []
				if (this.$route.meta && this.$route.meta.breadcrumb) {
					this.breadcrumbList.push({
						name: this.$route.meta.breadcrumb
					})
				}
			},
			toggleTheme() {
				this.isDark = !this.isDark
				if (this.isDark) {
					this.setDarkTheme()
					localStorage.setItem('theme', 'dark')
				} else {
					this.setLightTheme()
					localStorage.setItem('theme', 'light')
				}
				// 触发主题变化事件
				this.$root.$emit('theme-change', this.isDark)
			},
			setDarkTheme() {
				document.documentElement.classList.add('dark-theme')
			},
			setLightTheme() {
				document.documentElement.classList.remove('dark-theme')
			},
			handleUserCommand(command) {
				if (command === 'logout') {
					localStorage.removeItem('token')
					if (this.$router.resetDynamicRoutes) {
						this.$router.resetDynamicRoutes()
					}
					this.$store.dispatch('logout')
					this.$router.push('/login')
				} else if (command === 'changePassword') {
					this.showPasswordDialog = true
				}
			},
			handlePasswordSubmit() {
				this.$refs.passwordFormRef.validate((valid) => {
					if (valid) {
						this.passwordLoading = true
						api.post('/api/account/SelfChangeUserPassword',this.passwordForm)
							.then(res => {
								this.$message.success('密码修改成功，请重新登录')
								this.showPasswordDialog = false
								// 清空表单
								this.passwordForm = {
									oldPassword: '',
									newPassword: '',
									confirmNewPassword: ''
								}
								// 退出登录
								localStorage.removeItem('token')
								if (this.$router.resetDynamicRoutes) {
									localStorage.removeItem('token')
									this.$router.resetDynamicRoutes()
								}
								this.$store.dispatch('logout')
								this.$router.push('/login')
							})
							.catch(err => {
								this.$message.error(err.message || '密码修改失败')
							})
							.finally(() => {
								this.passwordLoading = false
							})
					}
				})
			},
			getUserInfo() {
				api.account.getUserInfo()
					.then(res => {
						this.$store.dispatch('login', res.data)
					})
					.catch(() => {
						// 获取用户信息失败，跳转到登录页面
						localStorage.removeItem('token')
						if (this.$router.resetDynamicRoutes) {
							this.$router.resetDynamicRoutes()
						}
						this.$router.push('/login')
					})
			}
		},
		beforeDestroy() {
			window.removeEventListener('menus-updated', this.handleMenusUpdated)
		}
	}
</script>
<style>
	
	.dark-theme  .el-card{
		background-color:    var(--bg-color-light)  !important;
		border-color:    var(--border-color)  !important;
	}
	/* 暗黑模式样式 */
		.dark-theme ::v-deep .view_title {
			color: #e4e7ed;
		}
	
		.dark-theme ::v-deep .el-form-item__label {
			color: #e4e7ed;
		}
	
		.dark-theme ::v-deep .el-input__inner {
			background-color: #333333;
			border-color: #404040;
			color: #e4e7ed;
		}
	
		.dark-theme ::v-deep .el-input__inner::placeholder {
			color: #909399;
		}
	
		.dark-theme ::v-deep .el-select .el-input__inner {
			background-color: #333333;
		}
	
		.dark-theme ::v-deep .el-input-number .el-input__inner {
			background-color: #333333;
		}
	
		.dark-theme ::v-deep .el-textarea__inner {
			background-color: #333333;
			border-color: #404040;
			color: #e4e7ed;
		}
	
		.dark-theme ::v-deep .el-textarea__inner::placeholder {
			color: #909399;
		}
	
		.dark-theme ::v-deep .el-radio {
			color: #e4e7ed;
		}
	
		.dark-theme ::v-deep .el-radio__label {
			color: #e4e7ed;
		}
	
		.dark-theme ::v-deep .el-divider__text {
			background-color: var(--bg-color);
			color: #409EFF;
		}
	
		.dark-theme ::v-deep .el-divider {
			background-color: #404040;
		}
	
		.dark-theme ::v-deep .el-dialog {
			background-color: #2a2a2a;
		}
	
		.dark-theme ::v-deep .el-dialog__title {
			color: #e4e7ed;
		}
	
		.dark-theme ::v-deep .el-dialog__headerbtn .el-dialog__close {
			color: #e4e7ed;
		}
	
		.dark-theme ::v-deep .el-dropdown-menu {
			background-color: #333333;
			border-color: #404040;
		}
	
		.dark-theme ::v-deep .el-dropdown-menu__item {
			color: #e4e7ed;
		}
	
		.dark-theme ::v-deep .el-dropdown-menu__item:hover {
			background-color: #404040;
		}
	
		.dark-theme ::v-deep .el-select-dropdown {
			background-color: #333333;
			border-color: #404040;
		}
	
		.dark-theme ::v-deep .el-select-dropdown__item {
			color: #e4e7ed;
		}
	
		.dark-theme ::v-deep .el-select-dropdown__item:hover {
			background-color: #404040;
		}
	
		.dark-theme ::v-deep .el-select-dropdown__item.selected {
			color: #409EFF;
		}
	
		.dark-theme ::v-deep .el-popper[x-placement^=bottom] .popper__arrow::after {
			border-bottom-color: #333333;
		}
	
		.dark-theme ::v-deep .el-popper[x-placement^=top] .popper__arrow::after {
			border-top-color: #333333;
		}
	
		.dark-theme ::v-deep .el-popper[x-placement^=left] .popper__arrow::after {
			border-left-color: #333333;
		}
	
		.dark-theme ::v-deep .el-popper[x-placement^=right] .popper__arrow::after {
			border-right-color: #333333;
		}
	
		.dark-theme ::v-deep .el-date-picker {
			background-color: #333333;
		}
	
		.dark-theme ::v-deep .el-picker-panel {
			background-color: #333333;
			color: #e4e7ed;
			border-color: #404040;
		}
	
		.dark-theme ::v-deep .el-date-picker__header-label {
			color: #e4e7ed;
		}
	
		.dark-theme ::v-deep .el-date-table th {
			color: #e4e7ed;
		}
	
		.dark-theme ::v-deep .el-date-table td .el-date-table-cell {
			color: #e4e7ed;
		}
	
		.dark-theme ::v-deep .el-date-table td.today .el-date-table-cell {
			color: #409EFF;
		}
	
		.dark-theme ::v-deep .el-date-table td.available:hover {
			background-color: #404040;
		}
	
		.dark-theme ::v-deep .el-time-panel {
			background-color: #333333;
			border-color: #404040;
		}
	
		.dark-theme ::v-deep .el-time-spinner__item {
			color: #e4e7ed;
		}
	
		.dark-theme ::v-deep .el-time-spinner__item:hover:not(.disabled):not(.active) {
			background-color: #404040;
		}
	
		.dark-theme ::v-deep .el-time-spinner__item.active:not(.disabled) {
			color: #409EFF;
		}
	
		.dark-theme ::v-deep .form_remark {
			color: #909399;
		}
		
</style>
<style scoped>
	.icp{
		text-align: center;
		padding: 20px 0 10px 0;
		color: #999;
	}
	.home-container {
		display: flex;
		height: 100vh;
		overflow: hidden;
		background-color: var(--bg-color-light);
		transition: all 0.3s ease;
	}

	.menu-sidebar {
		background-color: var(--bg-color);
		border-right: 1px solid var(--border-color);
		box-shadow: 2px 0 10px rgba(0, 0, 0, 0.05);
		transition: all 0.3s ease;
	}

	/* 菜单样式 */
	.el-menu-vertical-demo {
		border-right: none;
	}

	.el-menu {
		border-radius: 0;
	}

	.el-menu-item {
		height: 50px;
		line-height: 50px;
		margin: 10px 10px 0 10px;
		border-radius: 8px;
		font-size: 14px;
		transition: all 0.3s ease;
	}

	.el-menu-item:hover {
		background-color: rgba(64, 158, 255, 0.1) !important;
	}

	.el-menu-item.is-active {
		background-color: var(--primary-color) !important;
		color: white !important;
	}

	.el-menu-item.is-active i {
		color: white !important;
	}

	.top-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: var(--bg-color);
		border-bottom: 1px solid var(--border-color);
		padding: 0 24px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
		transition: all 0.3s ease;
	}

	.header-left {
		flex: 1;
	}

	.header-right {
		display: flex;
		align-items: center;
		gap: 16px;
	}

	/* 面包屑样式 */
	.el-breadcrumb {
		font-size: 14px;
	}

	.el-breadcrumb__inner {
		color: var(--text-color-secondary) !important;
		font-weight: 400;
	}

	.el-breadcrumb__inner.is-link {
		color: var(--primary-color) !important;
	}

	/* 主题切换按钮 */
	.theme-toggle {
		transition: all 0.3s ease;
	}

	.theme-toggle:hover {
		color: var(--primary-color);
		transform: scale(1.1);
	}

	/* 用户头像样式 */
	.user-avatar {
		display: flex;
		align-items: center;
		cursor: pointer;
		padding: 8px 12px;
		border-radius: 20px;
		transition: all 0.3s ease;
		background-color: var(--bg-color-light);
	}

	.user-avatar:hover {
		background-color: rgba(64, 158, 255, 0.1);
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}

	.user-avatar img {
		width: 32px;
		height: 32px;
		border-radius: 50%;
		margin-right: 8px;
		border: 2px solid var(--primary-color);
	}

	.user-name {
		font-size: 14px;
		font-weight: 500;
		color: var(--text-color);
		transition: all 0.3s ease;
	}

	.main-content {
		overflow-y: auto;
		background-color: var(--bg-color-light);
		transition: all 0.3s ease;
	}

	/* 响应式设计 */
	@media screen and (max-width: 768px) {
		.menu-sidebar {
			width: 180px !important;
		}

		.top-header {
			padding: 0 16px;
		}

	}
</style>
